<template>
  <div class="canvas_box">
    <canvas
      ref="canvasBox"
      id="canvasBox"
      @touchstart="touchstart"
      @touchmove="touchmove"
      @touchend="touchend"
      @mousedown="mouseDown"
      @mousemove="mouseMove"
      @mouseup="mouseUp"
    ></canvas>
    <!-- @mousedown="mouseDown"
      @mousemove="mouseMove"
      @mouseup="mouseUp" -->
    <div class="draw_action flex flex_end">
      <button class="btn_gray" @click="clear">清除</button>
      <button class="btn_primary" @click="enter">送出</button>
    </div>
  </div>
</template>

<style lang="scss">
.canvas_overflow{
  overflow: hidden;
}
.canvas_box {
  .draw_action {
    > button {
      width: 100px;
      margin: 0 5px;
    }
  }
}
</style>
<script>
export default {
  name: "canvasBox",
  data() {
    return {
      isMobile: false,
      height: 300,
      width: 550,
      canvas: null,
      ctx: "",
      x: 0,
      y: 0,
      drawing: false,
    };
  },
  props: {
    sign_name: "",
    index:null,
  },
  created() {
    const el=document.body
    // this.width = window.innerWidth;
  },
  methods: {
    draw(startX, startY, nextX, nextY) {
      this.ctx.beginPath();
      this.ctx.strokeStyle = "#000000";
      this.ctx.lineWidth = 3;
      this.ctx.moveTo(startX, startY);
      this.ctx.lineTo(nextX, nextY);
      this.ctx.stroke();
      this.ctx.closePath();
    },
    init() {
      //判斷手機還是平板
      // const mobileDevice = [
      //   "Android",
      //   "webOS",
      //   "iPhone",
      //   "iPad",
      //   "iPod",
      //   "BlackBerry",
      //   "Windows Phone",
      // ];
      // this.isMobile = mobileDevice.some((e) => {
      //   return navigator.userAgent.includes(e);
      // });
      this.canvas = this.$refs.canvasBox;
      this.canvas.height = this.height;
      this.canvas.width = this.width;
      this.ctx = this.canvas.getContext("2d");
    },
    touchstart(e) {
      //star
      e.preventDefault();
      const rect = this.canvas.getBoundingClientRect();
      const coordinateX = e.targetTouches[0].clientX- rect.left ;
      const coordinateY = e.targetTouches[0].clientY- rect.top;
      
      this.x = coordinateX ;
      this.y = coordinateY;
      this.drawing = true;
      this.draw(this.x, this.y, coordinateX, coordinateY);
    },
    touchmove(e) {
      //keep
      e.preventDefault();
      if (this.drawing === true) {
        const rect = this.canvas.getBoundingClientRect();
        const coordinateX = e.targetTouches[0].clientX- rect.left ;
        const coordinateY =  e.targetTouches[0].clientY- rect.top;
        
        this.draw(this.x, this.y, coordinateX, coordinateY);
        this.x = coordinateX;
        this.y = coordinateY;
      }
    },
    touchend(e) {
      //done
      const rect = this.canvas.getBoundingClientRect();
      e.preventDefault();
      const coordinateX =  e.changedTouches[0].clientX- rect.left ;
      const coordinateY = e.changedTouches[0].clientY - rect.top;
      if (this.drawing === true) {
        this.draw(this.x, this.y, coordinateX, coordinateY);
        this.x = 0;
        this.y = 0;
        this.drawing = false;
      }
    },
    mouseDown(e){
      //star
      const rect = this.canvas.getBoundingClientRect();
      const coordinateX = e.clientX- rect.left ;
      const coordinateY = e.clientY- rect.top;
      this.x = coordinateX ;
      this.y = coordinateY;
      this.drawing = true;
      // this.draw(this.x, this.y, coordinateX, coordinateY);
    },
    mouseMove(e){
      if (this.drawing === true) {
        const rect = this.canvas.getBoundingClientRect();
        const coordinateX = e.offsetX ;
        const coordinateY =  e.offsetY;
        this.draw(this.x, this.y, coordinateX, coordinateY);
        this.x = coordinateX;
        this.y = coordinateY;
      }

    },
    mouseUp(e){
      const coordinateX =  e.offsetX  ;
      const coordinateY = e.offsetY;
      if (this.drawing === true) {
        this.draw(this.x, this.y, coordinateX, coordinateY);
        this.x = 0;
        this.y = 0;
        this.drawing = false;
      }      
    },


    clear() {
      this.ctx.clearRect(0, 0, this.width, this.height);
    },
    enter() {
      //console.log(this.canvas.toDataURL());
      this.$emit("transfromIMG", this.canvas.toDataURL(), this.sign_name,this.index);
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {
    const el=document.body 
  },
};
</script>
